/** First letters of the first two words — matches procure-mobile `splitNameInitial`. */
export function splitNameInitial(text = 'User'): string {
  const value = (text || 'User').trim() || 'User';
  const parts = value.split(/\s+/);
  let initials = parts[0]?.[0] ?? 'U';
  if (parts.length > 1 && parts[1]?.[0]) {
    initials += parts[1][0];
  }
  return initials.toUpperCase();
}
